// Global configuration file

export const baseUrl = 'https://appapi.oncloudapi.com'            
export const parentUrl = 'https://apps.oncloudapi.com'    
export const frontUrl = 'https://checkout.oncloudapi.com'    

export const Color = {
  primary: '#0ea5e9',
  secondary: '#d946ef',
  background: '#f8fafc',
  background1: '#e2e8f0',
  background2: '#cbd5e1',
  background3: '#94a3b8',
  white: '#ffffff',
  gray: '#0f172a',
  gray: '#64748b',
  colorgray_100: '#94a3b8',
  colorgray: '#1e293b',
};

export const FontFamily = {
  regular: 'Inter, sans-serif',
  bold: 'Poppins, sans-serif',
};

export const FontSize = {
  headline_size: '24px',
  headline3_size: '18px',
  size_3xs: '12px',
  font_size: '14px',
  pxRegular_size: '16px',
};